import {computed, inject, Injectable, signal} from '@angular/core';
import {LocalStorageService} from './storage.service';
import {ApiAppService} from '@kilobytelab/domain';
import {Aviso} from '@kilobytelab/types';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class AvisosService {

  private appService = inject(AppService);
  private localstorage = inject(LocalStorageService);
  private apiApp = inject(ApiAppService);

  AVISOS = signal<{idAlumno: number, avisos: (Aviso & {time?: string, show?: boolean})[]}[]>([]);

  avisoDisponible = computed<boolean>(() => {
    const alumnoActivo = this.appService.ALUMNO();
    const status = this.appService.fechas();
    const avisos = this.AVISOS();
    if (!alumnoActivo || !avisos?.length) return false;
    const avisosAlumno: Aviso[] = this.AVISOS().find(e => e.idAlumno === alumnoActivo.id)?.avisos;
    if (!avisosAlumno?.length) return false;
    const fechaStatus = status?.avisos;
    if (!fechaStatus) return true;
    const fechaUltimoEvento = String(avisosAlumno[0].momento);
    const fechaVisto = String(fechaStatus);
    return fechaUltimoEvento > fechaVisto
  });

  async marcarAvisosComoVisto() {
    const ahora = new Date().toISOString();
    this.appService.fechas.update(fechas => ({...fechas, avisos: ahora}));
    await this.localstorage.setFechas(this.appService.fechas())
  }

  async checkAvisos() {
    const alumnos = this.appService.PADRE();
    if (!alumnos?.length) {
      this.AVISOS.set([]);
      await this.localstorage.setAvisos([]);
      return
    }
    try {
      const peticiones = alumnos.map(async (alumno) => {
        const eventos: Aviso[] = await this.apiApp.getAvisos(alumno.id);
        this.updateAvisos(alumno.id, eventos)
      });
      await Promise.all(peticiones);
      return this.localstorage.setAvisos(this.AVISOS())
    } catch (err) {
      const guardados: {idAlumno: number, avisos: Aviso[]}[] = await this.localstorage.getAvisos();
      if (!guardados) {
        throw new Error('Error recuperando los avisos')
      }
      this.AVISOS.set(guardados)
    }
  }

  private updateAvisos(id: number, nuevos: Aviso[]) {
    this.AVISOS.update(avisos => {
      const index = avisos.findIndex(a => a.idAlumno === id);
      if (index === -1) return [...avisos, {idAlumno: id, avisos: nuevos}];
      const avisosClonados = [...avisos];
      const avisoActual = avisosClonados[index];
      if (!avisoActual.avisos?.length) {
        avisosClonados[index] = { ...avisoActual, avisos: nuevos };
        return avisosClonados
      }
      const eventosFusionados = nuevos.map(a => {
        const ev = avisoActual.avisos.find(av => av.id === a.id);
        return ev ? { ...ev, ...a } : a
      });
      avisosClonados[index] = { ...avisoActual, avisos: eventosFusionados };
      return avisosClonados
    })
  }

}